export default function Style(){
  return (
    <style>
      {`
      .aminitiesWellington1 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(/static/images/landingPages/fitness-room.png);
  background-size: cover;
  color: white;
}

.aminitiesWellington2 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(/static/images/landingPages/movie-theater.png);
  background-size: cover;
  color: white;
}

.aminitiesWellington3 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(/static/images/landingPages/mini-golf.png);
  background-size: cover;
  color: white;
}

.aminitiesWellington4 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(/static/images/landingPages/pool-table.png);
  background-size: cover;
  color: white;
}
.fs-card-res
.fw-400{
    font-weight: 400 !important;
}
@media (max-width: 768px) {
  .fs-card-res {
    font-size: 28px !important;
  }
}
@media (max-width: 992px) {
  .fs-card-res {
    font-size: 30px !important;
  }
}



@media (max-width: 1534px) {
  .fs-card-res {
    font-size: 32px !important;
  }
}



@media (min-width: 1543px) {
  .fs-card-res {
    font-size: 36px !important;
    line-height: 45px !important;
  }
}
      `}
    </style>
  );
}
